import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    loadDefaultStatuses: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'my-workspace/load-default-statuses',
                    method: 'GET',
                    types: [
                        types.MY_WORKSPACE_LOAD_DEFAULT_STATUSES_REQUEST,
                        types.MY_WORKSPACE_LOAD_DEFAULT_STATUSES_SUCCESS,
                        types.MY_WORKSPACE_LOAD_DEFAULT_STATUSES_FAILURE
                    ]
                }
            });
        }
    },
    myTasksByStatus: (filterRequest) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: `my-workspace/my-tasks-by-status`,
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.MY_WORKSPACE_MY_TASKS_BY_STATUS_REQUEST,
                        types.MY_WORKSPACE_MY_TASKS_BY_STATUS_SUCCESS,
                        types.MY_WORKSPACE_MY_TASKS_BY_STATUS_FAILURE
                    ]
                }
            });
        }
    },
}
